<form class='form-inline full-width'>
  <fieldset [ngClass]="{'w-100': isHalfAndHalf}">
    <legend class="sr-only">{{'component.item_editor.item_editor_controls.item_controls' | translate}}</legend>
    <div class="item-options-wrapper">

      <div class='controls-price-calories-wrapper'>
        <div class='size-quantity-wrapper' [ngClass]="{'in-modal': inItemEditorModal && (viewPort$ | async)?.isTablet}">
          <div class='control-wrapper'>
            <div class="form-group" [ngClass]="{'no-margin': (viewPort$ | async)?.isMobile}">
              <div class='fw-400 option-label' for="quantityInput">{{'component.item_editor.item_editor_controls.quantity' | translate}}</div>
              <fts-quantities
                *ngIf="(viewPort$ | async)?.isMobile"
                [(selectedQuantity)]="item.quantity"
                (selectedQuantityChange)="onQuantityChanged($event)"
                [needsOverlay]="true"
                [minimumQuantity]="orderableItem?.minimumQuantity"
                [bubbleUpErrors]="true"
                [describedBy]="(errors | errorList) | generateIds : 'item-editor-control-error'"
                (quantityError)="onQuantityError($event)"
              ></fts-quantities>
              <fts-quantity-selector
                *ngIf="!(viewPort$ | async)?.isMobile"
                id='quantityInput'
                class='fw-500'
                [(quantity)]='item.quantity'
                (quantityChange)='onQuantityChanged($event)'
                [minimumQuantity]="orderableItem?.minimumQuantity"
                [bubbleUpErrors]="true"
                [describedBy]="(errors | errorList) | generateIds : 'item-editor-control-error'"
                (quantityError)="onQuantityError($event)"
              ></fts-quantity-selector>
            </div>
          </div>

          <div class='control-wrapper size-selection-wrapper' *ngIf="!hasSingleSize">
            <div class="form-group select"
              [ngClass]="{'no-margin': (viewPort$ | async)?.isMobile, 'select-dropdown': !hasOnlyOneSizeAvailable}">
              <label class='fw-400 option-label'
                [ngClass]="{'text-danger': !(orderableItem?.sizePrices | propInArray : 'size' : item.size)}"
                for="sizeInput">{{'component.item_editor.item_editor_controls.size' | translate}}</label>
              <select
                name="size"
                id="sizeInput"
                class="form-control primary-text-color fw-500 full-width-important"
                [ngClass]="{'overlay': (viewPort$ | async)?.isMobile}"
                [(ngModel)]='item.size'
                (ngModelChange)='onSizeChanged($event)'
                *ngIf="!hasOnlyOneSizeAvailable">
                <option *ngFor='let sizePrice of orderableItem?.availableSizePrices | recipeDeterminantSizePricesFilter:allIngredients:orderableIngredients:storeConfig?.showSizeSpecificIngredients; trackBy: trackBySize'
                        [value]='sizePrice.size'>
                  {{sizePrice.label}}
                  <ng-container *ngIf='sizePrice.servings'>({{sizePrice | servings}})</ng-container>
                </option>
              </select>
              <fa-icon class="sort-icon" aria-hidden="true" [icon]="faSort"></fa-icon>
              <input
                name="size"
                id="sizeInput"
                [ngModel]="item.size"
                class="form-control primary-text-color fw-500"
                [ngClass]="(viewPort$ | async)?.isMobile ? 'overlay' : 'primary-bg-color'"
                disabled="true"
                *ngIf="hasOnlyOneSizeAvailable">
            </div>
          </div>

          <div class='control-wrapper price-input-wrapper' *ngIf="(viewPort$ | async)?.isMobile && !isHalfAndHalf">
            <div class="form-group no-margin">
              <label class='fw-400 option-label' for="priceInput">{{'component.item_editor.item_editor_controls.price' | translate}}</label>
              <input class="form-control primary-text-color fw-500 price-input" name="price" id="priceInput" [ngModel]="price | currency:'USD':'symbol'" disabled="true">
            </div>
          </div>
        </div>

        <div class="w-100">
          <div [@expanded]="{value: !!error, params: {speed: '100ms'}}"
               role="alert"
               class="alert alert-danger w-100 mb-0 mt-2"
               id="item-editor-control-error-{{i}}"
               *ngFor="let error of (errors | errorList); let i = index">{{error}}</div>
        </div>

        <div *ngIf="!(viewPort$ | async)?.isMobile" class='size-calories-wrapper'>
          <div class="price-wrapper">
            <fts-price [price]='price'></fts-price>
          </div>
        </div>
      </div>

      <div class='action-button-wrapper text-right' *ngIf="(!ingredientChoicesAsSteps || isHalfAndHalf) && !(viewPort$ | async)?.isMobile && (!inItemEditorModal || isHalfAndHalf) && !((viewPort$ | async)?.isMobile && isHalfAndHalf)">
        <button
          ftsAsyncButton
          [disabled]="isHalfAndHalf && disableOrderButton"
          [subscription]='updatingOrderSubscription'
          class='btn action-bg-color action-inverse-text-color shadowed action-btn font-secondary text-uppercase'
          (click)="onOrderUpdate()">
          {{(item.itemId ? 'component.item_editor.item_editor_controls.update' : 'component.item_editor.item_editor_controls.add_order') | translate}}
        </button>
      </div>
      <div class=' text-right' style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding-top:10px;" *ngIf="(viewPort$ | async)?.isMobile && isHalfAndHalf">
        <span style="font-size: 1.1rem;">{{'component.item_editor.item_editor_controls.price' | translate}}:<span style="font-weight: 500;">{{price | currency:'USD':'symbol'}}</span></span>
        <button
          ftsAsyncButton
          [disabled]="isHalfAndHalf && disableOrderButton"
          [subscription]='updatingOrderSubscription'
          class='btn action-bg-color action-inverse-text-color shadowed action-btn font-secondary text-uppercase'
          (click)="onOrderUpdate()">
          {{(item.itemId ? 'component.item_editor.item_editor_controls.update' : 'component.item_editor.item_editor_controls.add_order') | translate}}
        </button>
      </div>
    </div>
  </fieldset>
</form>
